"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M38 13v19l-3.405.011a.5.5 0 0 0-.349.862L40 38.615l5.766-5.742a.5.5 0 0 0-.349-.862L42 32V13a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1z" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "28", x: "4", y: "12" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "24", x: "4", y: "22" }),
  React.createElement("rect", { height: "4", rx: "1", ry: "1", width: "20", x: "4", y: "32" })
);

